export interface SubmitLensState {
    submitUnderDifferentUser: boolean;
    isExclusiveLens: boolean;
}

export const defaultSubmitLensState: Readonly<SubmitLensState> = {
    submitUnderDifferentUser: false,
    isExclusiveLens: false,
};
